import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Card, Typography, Button, message, Form } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import AppConfig from "../config/AppConfig";
import { getCompanie } from "../../Api/Apis";
import { addEmail } from "../../Api/RegistrationApis";

const { Text } = Typography;

const Companies2 = () => {
  //   const history = useHistory();
  const location = useLocation();

  // from navigation state or fallback
  const formData = location.state?.formData || {};
  const questionnaireId =
    location.state?.questionnaireId ||
    (() => {
      try {
        return (
          JSON.parse(
            localStorage.getItem("BusinessQuestionnaireId") || "null"
          ) || JSON.parse(localStorage.getItem("Step8") || "null")
        );
      } catch {
        return (
          localStorage.getItem("BusinessQuestionnaireId") ||
          localStorage.getItem("Step8")
        );
      }
    })();

  const [companies, setCompanies] = useState([]);
  const [matchingList, setMatchingList] = useState([])
  const [loading, setLoading] = useState(true);

  const getRecipientEmail = () => {
  const fromForm = (formData?.email || "").trim();
  if (fromForm) return fromForm;

  // 2) try loginDetails from localStorage (saved on sign-in)
  try {
    const ld = JSON.parse(localStorage.getItem("loginDetails") || "null");
    if (ld?.email) return String(ld.email).trim();
  } catch {}

  // 3) optional: your flow may have stashed email separately
  try {
    const cached = JSON.parse(localStorage.getItem("BusinessSignupEmail") || "null");
    if (cached) return String(cached).trim();
  } catch {}

  return "";
};

  // summary values for header
  const summaryFromMatches = useMemo(() => {
    if (!companies || companies.length === 0) return {};
    const first = companies[0];
    return {
      industry: Array.isArray(first.industry)
        ? first.industry.join(", ")
        : first.industry || "—",
      ageGroup: Array.isArray(first.ageGroup)
        ? first.ageGroup.join(", ")
        : first.ageGroup || "—",
      budget: Array.isArray(first.ranges)
        ? first.ranges.join(", ")
        : first.ranges || "—",
    };
  }, [companies]);

  // UPDATED: summary prefers formData but falls back to companies
  const summary = React.useMemo(() => {
    // normalize formData shapes
    const fdIndustry = Array.isArray(formData?.industry)
      ? formData.industry.join(", ")
      : formData?.industry || formData?.industries;

    const fdAge = Array.isArray(formData?.agegroup)
      ? formData.agegroup.join(", ")
      : formData?.agegroup || formData?.ageGroup;

    const fdBudget = formData?.rangeGoals || formData?.budget;

    return {
      industry: fdIndustry || summaryFromMatches.industry || "—",
      ageGroup: fdAge || summaryFromMatches.ageGroup || "—",
      budget: fdBudget || summaryFromMatches.budget || "—",
    };
  }, [formData, summaryFromMatches]);

  useEffect(() => {
    const run = async () => {
      if (!questionnaireId) {
        message.error(
          "Missing questionnaire id. Please complete the form again."
        );
        setLoading(false);
        return;
      }

      try {
        const res = await getCompanie(
          AppConfig.entityNames.getCompanies,
          questionnaireId
        );
        if (res?.success && Array.isArray(res.data)) {
          setCompanies(res.data);
          setMatchingList(res.data);
          if (res.data.length === 0) {
            message.info(
              "No exact matches yet. We’ll notify you as providers join."
            );
          }
        } else {
          message.error("Failed to fetch matched companies.");
        }
      } catch (e) {
        console.error("getCompanie error:", e);
        message.error("Something went wrong while fetching matches.");
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [questionnaireId]);

  const tag = (txt, i) => (
    <Button
      key={`${txt}-${i}`}
      size="small"
      style={{
        backgroundColor: "#9baebc",
        color: "#fff",
        marginRight: 6,
        marginBottom: 6,
        border: "none",
        borderRadius: 12,
      }}
    >
      {txt}
    </Button>
  );
 const handleSubmit = async () => {
  try {
    const recipientEmail = getRecipientEmail();
    if (!recipientEmail) {
      message.warning("Missing recipient email.");
      return;
    }

    const payload = {
      entityData: {
        matchingList: matchingList.length ? matchingList : companies,
        matchEmail: recipientEmail,
        industry: formData?.industry || summary.industry || "",
        ageGroup: formData?.agegroup || [],
        rangeGoals: formData?.rangeGoals || summary.budget || "",
      },
    };

    const res = await addEmail(AppConfig.entityNames.sendMail, payload);
    if (res?.success) {
      message.success("Email sent successfully.");
    } else {
      message.error(res?.message || "Could not send email.");
    }
  } catch (e) {
    console.error("addEmail error:", e);
    message.error("Something went wrong sending your email.");
  }
};


  return (
    <Row>
      {/* <Form onSubmit={handleSubmit} style={{ marginBottom: "10%" }}> */}
      <Col span={24}>
        <div style={{ textAlign: "center", marginTop: "100px" }}>
          <h1 style={{ fontWeight: "bold" }}>
            We found {companies.length} companies who <br />
            can help you based on your search criteria
          </h1>
        </div>
      </Col>
      <Col span={12} style={{ marginLeft: "26%" }}>
        <Row>
          <Col
            xxl={{ span: 8 }}
            xl={{ span: 8 }}
            lg={{ span: 8 }}
            md={{ span: 8 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
          >
            <span style={{ fontSize: "18px" }}>
              <b>Industry</b>
            </span>
            <Row>
              <h4>{summary.industry}</h4>
            </Row>
          </Col>

          <Col
            xxl={{ span: 8 }}
            xl={{ span: 8 }}
            lg={{ span: 8 }}
            md={{ span: 8 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
          >
            <span style={{ fontSize: "18px" }}>
              <b>Age Group</b>
            </span>
            <Row>
              <h4>{summary.ageGroup}</h4>
            </Row>
          </Col>
          <Col
            xxl={{ span: 8 }}
            xl={{ span: 8 }}
            lg={{ span: 8 }}
            md={{ span: 8 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
          >
            <span style={{ fontSize: "18px" }}>
              <b>Budget </b>
            </span>
            <Row>
              <h4>{summary.budget}</h4>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <p
          style={{
            color: "gray",
            textAlign: "center",
            lineHeight: "20px",
          }}
        >
          You can expect to be contacted by agencies who <br /> specialize in
          your industry.
        </p>
      </Col>
      <Col lg={12} md={12} sm={19} xs={19} style={{ marginLeft: "45%" }}>
        <Col span={12}>
          {/* <Link to="/app/Companies"> */}
          <Button
            key="1"
            type="primary"
            // loading={this.state.loading}
            onClick={handleSubmit}
            htmlType="submit"
            style={{
              borderRadius: "50px",
              backgroundColor: "#dce7f0",
              color: "#004b84",
              fontSize: "13px",
              width: "185px",
              border: "none",
              fontWeight: "bold",
              height: "40px",
            }}
          >
            <MailOutlined />
            Email me this list
          </Button>
          {/* </Link> */}
        </Col>
      </Col>
      <Col span={16} offset={4}>
        <Card
          loading={loading}
          style={{ marginTop: 30, borderRadius: 10 }}
          bodyStyle={{ padding: 20 }}
        >
          {companies.length === 0 && !loading ? (
            <div style={{ textAlign: "center", color: "#888" }}>
              No matches yet. We’ll notify you as providers join.
            </div>
          ) : (
            companies.map((c, idx) => (
              <Card
                key={idx}
                bordered={false}
                style={{
                  borderRadius: 10,
                  marginBottom: 16,
                  border: "1px solid #eee",
                }}
                bodyStyle={{ padding: 16 }}
              >
                <Row gutter={[16, 8]}>
                  <Col
                    xxl={{ span: 10, offset: 2 }}
                    xl={{ span: 10, offset: 2 }}
                    lg={{ span: 12 }}
                    md={{ span: 12 }}
                    sm={{ span: 12 }}
                    xs={{ span: 12 }}
                  >
                    <Text strong>Contact Person Name</Text>
                    <div style={{ fontSize: 15, color: "#111" }}>
                      {c.businessName || "—"}
                    </div>

                    <div style={{ marginTop: 8 }}>
                      {(c.area || []).map((a, i) => tag(a, i))}
                    </div>
                  </Col>

                  <Col xs={24} md={12}>
                    <Text strong>Contact Person Details</Text>
                    <div style={{ fontSize: 15, color: "#111" }}>
                      {c.contactPerson || "—"}
                    </div>
                    <div style={{ fontSize: 15, color: "#111" }}>
                      {c.phoneNumber || "—"}
                    </div>
                    <div style={{ fontSize: 15, color: "#111" }}>
                      {c.email || "—"}
                    </div>
                  </Col>
                </Row>
              </Card>
            ))
          )}
        </Card>
      </Col>
      {/* </Form> */}
    </Row>
  );
};

export default Companies2;
